import React from 'react';
import styles from './AiSummary.module.css';

// Written per period ahead of time and read from `ai_insights`. French is never
// generated, so `summary_fr` / `insights_fr` are deliberately not read here.
//
// Both blocks are always drawn, empty or not. A block that removes itself reads
// as a missing feature rather than as nothing to say, and hiding them one at a
// time collapsed the two-column layout whenever only one of the pair had
// content — which is the usual case on a report, where a summary is written but
// insights often are not.
const Block = ({ heading, lines, emptyMessage }) => (
	<div className={styles.block}>
		<h3 className={styles.title}>{heading}</h3>
		{lines.length > 0 ? (
			<ul className={styles.list}>
				{lines.map((line) => (
					<li key={line} className={styles.line}>
						{line}
					</li>
				))}
			</ul>
		) : (
			<p className={styles.empty}>{emptyMessage}</p>
		)}
	</div>
);

const AiSummary = ({
	title,
	summary = [],
	insights = [],
	emptyMessage = 'Nothing to show for this period yet.',
}) => (
	<section className={styles.wrapper}>
		<div className={styles.columns}>
			<Block heading={title} lines={summary} emptyMessage={emptyMessage} />
			<Block heading='Insights' lines={insights} emptyMessage={emptyMessage} />
		</div>

		<p className={styles.caption}>
			AI Summary &amp; Insights based on tracking indicators, self-tracking and
			journal entries
		</p>
	</section>
);

export default AiSummary;
